import { useStrictInstance } from '@funtech-int/rival-react';

import { Logger } from '@kinopoisk-int/logger';

import { loggerRef } from '../lib/logger';

export function useLogger(): Logger {
    return useStrictInstance(loggerRef);
}
